import { render } from "./WhatDoOne.vue?vue&type=template&id=4b1a22aa&scoped=true"
import script from "./WhatDoOne.vue?vue&type=script&lang=js"
export * from "./WhatDoOne.vue?vue&type=script&lang=js"

import "./WhatDoOne.vue?vue&type=style&index=0&id=4b1a22aa&scoped=true&lang=scss"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1a22aa"]])

export default __exports__